import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '浩连科技 - 软件定制开发服务商' }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: { title: '关于我们 - 浩连科技' }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import(/* webpackChunkName: "services" */ '../views/ServicesView.vue'),
    meta: { title: '产品服务 - 浩连科技' }
  },
  {
    path: '/cases',
    name: 'cases',
    component: () => import(/* webpackChunkName: "cases" */ '../views/CasesView.vue'),
    meta: { title: '案例展示 - 浩连科技' }
  },
  {
    path: '/cases/:id',
    name: 'case-detail',
    component: () =>
      import(/* webpackChunkName: "case-detail" */ '../views/CaseDetailView.vue'),
    meta: { title: '案例详情 - 浩连科技' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue'),
    meta: { title: '联系我们 - 浩连科技' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  // history 模式 URL 更美观，部署时需将非静态资源请求回退到 index.html
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, top: 84, behavior: 'smooth' }
    }
    return { top: 0 }
  }
})

router.afterEach(to => {
  const title = to.meta.title
  if (title) {
    document.title = title
  }
})

export default router
